import { CloseOutlined } from "@ant-design/icons";
import { Button, DatePicker, Form, Select } from "antd";
import { useEffect, useState } from "react";
import "./rep-abon-filter.css"

const RepAbonFilter = ({ current, onClose, periodType = [], employeeType = [], products = [], onRefresh }) => {
  const [item, setItem] = useState({
    periodType: null,
    startDate: null,
    endDate: null,
    specificProductIds: [],
    employeeType: null,
    ...current
  });
  const [form] = Form.useForm();

  useEffect(() => { 
    form.setFieldsValue(current);
  }, [current]);

  const onValuesChange = (value) => {
    const updatedItem = {...item, ...value};
    setItem(updatedItem);
  }

  const onSave = () => {
    onRefresh();
    onClose(item);
  }

  const customTagRender = (props) => {
    return <span className="filters-tag-label">{props.label}</span>;
  };

  return (
    <div className="sport-modal">
      <div className="sport-modal-overlay" onMouseDown={e => e.target === e.currentTarget && onClose(false)}>
        <div className="sport-modal-content" onMouseDown={e => e.stopPropagation()}>
          <div className="sport-modal-title">
            <span>Параметры отчета</span>
            <CloseOutlined className="sport-section-title-close" onClick={() => onClose()}/>
          </div>
          <Form form={form} onValuesChange={onValuesChange} layout="inline" colon={false}>
            <Form.Item name="periodType" label="Период">
              <Select
                allowClear={false}
                options={periodType}
                className="filters-select"
                placeholder="Выберите период"
              />
            </Form.Item>
            <Form.Item name="startDate" label="с">
              <DatePicker format="DD.MM.YYYY"/>
            </Form.Item>
            <Form.Item name="endDate" label="по">
              <DatePicker format="DD.MM.YYYY"/>
            </Form.Item>
            <Form.Item name="specificProductIds" label="Продукты">
              <Select
                allowClear={false}
                mode="multiple"
                options={products.map(product => ({ value: product.id, label: product.name }))}
                className="filters-select"
                placeholder="Все"
                maxTagCount={2}
                tagRender={customTagRender}
              />
            </Form.Item>
            <Form.Item name="employeeType" label="Сотрудники">
              <Select
                allowClear={false}
                options={employeeType}
                className="filters-select"
                placeholder="Все сотрудники"
                tagRender={customTagRender}
              />
            </Form.Item>
            <Form.Item>
              <Button className="sport-btn" onClick={onSave}>ОК</Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
}

export default RepAbonFilter;
